// extracted by mini-css-extract-plugin
export default {"elements":"TeamMemberTags_elements__LY5QR"};